module.exports = __webpack_public_path__ + "img/part-5-title.d0349231.png";